import ACHImg from './img-ach.svg'

const Images = {
  ACH: ACHImg,
  DEFAULT: ACHImg, // as a default icon for ACH
}

export default Images
